module.exports = __webpack_public_path__ + "lose-8651be6260392f91da30.png";